import { 
  // useNavigate,
  useParams } from 'react-router-dom';
// import { ArrowLeft } from 'lucide-react';
import { getErrorMessage } from '@/shared/api/errors';
import { usePolicyContentQuery } from '@/features/policies/api/usePolicyQueries';
import { PolicyHtmlContent } from '@/features/policies/components/PolicyHtmlContent';
import { formatPolicySlug } from '@/features/policies/types/policy';

export function PolicySlugPage() {
  const { slug } = useParams<{ slug: string }>();
  // const navigate = useNavigate();
  const contentQuery = usePolicyContentQuery(slug || null);
  const content = contentQuery.data?.data;
  const error =
    contentQuery.isError
      ? getErrorMessage(contentQuery.error, 'Failed to load policy')
      : contentQuery.data && contentQuery.data.success === false
        ? contentQuery.data.message || 'Failed to load policy'
        : null;

  return (
    <div className="min-h-screen bg-white text-left">
      <div className="border-b border-[var(--dash-line)] bg-[#f8faff] py-6 md:py-8">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          {/* <button
            type="button"
            onClick={() => navigate(-1)}
            className="mb-5 inline-flex items-center gap-2 rounded-xl border border-[var(--dash-line)] bg-white px-3.5 py-2 text-sm font-semibold text-[var(--dash-muted)] transition hover:text-[var(--dash-brand)]"
          >
            <ArrowLeft className="h-4 w-4" />
            Back
          </button> */}
          <h1 className="m-0 text-3xl font-extrabold tracking-tight text-[var(--dash-brand)] capitalize md:text-4xl">
            {content?.title || formatPolicySlug(slug)}
          </h1>
          <div
            className="mt-5 h-1.5 w-24 rounded-full"
            style={{
              background:
                'linear-gradient(90deg, #8E58A6 0%, #145E8C 50%, #33A65B 100%)',
            }}
          />
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-5 py-8 sm:px-8 md:py-10">
        <PolicyHtmlContent
          html={content?.content}
          loading={contentQuery.isPending}
          error={error}
        />
      </div>
    </div>
  );
}
